import React from 'react';
import { BrowserRouter, Routes, Route, HashRouter } from 'react-router-dom';
import { MenuBar } from './components/MenuBar';
import { NotFound } from './components/NotFound';
import { ImagePlayer } from './components/ImagePlayer';
import TestPage from './components/TestPage'; 
import "@fontsource/inter"
import "./App.css"
import { GameCards } from 'components/GameCards';
import { HomePage } from 'pages/HomePage';
import { GamePage } from 'pages/GamePage';
import ScrollToTop from 'utils/ScrollToTop';
import { ConfigProvider, theme } from 'antd';
import { AboutPage } from 'pages/AboutPage';

const a = {
	token: {
		colorPrimary: '#08142c',
		colorInfo: '#fa8c16',
		colorLink: '#1f7df2',
		fontSize: 14,
		fontFamily:
			"inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
	},
	components: {
		Button: {
			colorPrimary: '#1f7df2',
			algorithm: true, // Enable algorithm
			fontWeight: 500,
			paddingBlock: 4, //vertical
			paddingInline: 40, //horizontal
			contentFontSize: 14,
		},
	},
};

function App() {
	return (
		<>
			<ConfigProvider theme={a}>
				<MenuBar />
				<ScrollToTop />
				<Routes>
					<Route>
						<Route index element={<HomePage />} />
						<Route path="/games/*" element={<GameCards />} />
						<Route path="/games/:gameURL" element={<GamePage />} />
						<Route path="/about" element={<AboutPage />} />
						<Route path="*" element={<NotFound />} />
					</Route>
				</Routes>
			</ConfigProvider>
		</>
	);
}

export default App;
